module.exports = __webpack_public_path__ + "static/paper-medical-records-1a721bc229f5776585576f237e24318e.png";